export default __webpack_public_path__ + "static/media/les_andelys11.410017b3.jpg";